import {
  StoryblokServerComponent,
  storyblokEditable,
} from "@storyblok/react/rsc";
import type { Page, StoryblokComponent } from "@/types/storyblok";

// biome-ignore lint/suspicious/noRedeclare: Page is used for type safety
export default function Page({ blok }: { blok: Page }) {
  return (
    // biome-ignore lint/suspicious/noExplicitAny: Required for Storyblok React compatibility
    <main {...storyblokEditable(blok as any)}>
      {blok.body?.map((nestedBlok: StoryblokComponent) => (
        <StoryblokServerComponent
          // biome-ignore lint/suspicious/noExplicitAny: Required for Storyblok React compatibility
          blok={nestedBlok as any}
          key={nestedBlok._uid}
        />
      ))}
    </main>
  );
}
